import httpClient from './httpClient'

export default {
  async resendPassword(email) {
    let ret = await httpClient.post('user/resend-password', { email: email })
    return ret
  },
  async getApiKey() {
    let ret = await httpClient.get('user/apikey')
    return ret
  },
  async createApiKey() {
    let ret = await httpClient.post('user/apikey')
    return ret
  },
  async deleteApiKey() {
    let ret = await httpClient.delete('user/apikey')
    return ret
  },
  async getUserLimit() {
    let ret = await httpClient.get('user/limit')
    return ret
  },
  async fixUserLimit() {
    let ret = await httpClient.post('user/limit')
    return ret
  },
  async logoutSessions() {
    let ret = await httpClient.post('users/?logoutSessions')
    return ret
  },
  async changeEmail({ id, email, beta }) {
    let ret = await httpClient({
      method: 'PUT',
      url: `users/${id}${beta ? '?beta=1' : ''}`,
      data: {
        email,
        type: 'pre_update_email',
      },
    })
    return ret
  },
  async confirmChangeEmail({ id, uuid }) {
    let ret = await httpClient({
      method: 'PUT',
      url: `users/${id}`,
      data: {
        uuid,
        type: 'update_email',
      },
    })
    return ret
  },
  async getUserDataByID({ id }) {
    let ret = await httpClient.get(`users/${id}`)
    return ret
  },
  async updateUserAvatar({ id, data }) {
    let ret = await httpClient({
      method: 'PUT',
      url: `users/${id}`,
      data,
    })
    return ret
  },
}
